module.exports = __webpack_public_path__ + "static/media/Lumena-logo.1eb82921.webp";